<div class="container">
    <!-- 地图区域 -->
    <div #map class="map"></div>
</div>